<template>
  <a-card :bordered='false'>
    <div class="outBox"  >
    <div class="insideBox s_flex_ali" >
      <p >此分类功能只便于后台人员管理产品库，如需要在云店商城前端进行商品分类展示 ，请到<a  :href="link" target="_blank" class="s_c376" style="cursor: pointer;">商城商品分类</a>操作. </p>
    </div>
  </div>
    <div class='mb25 m-b-45 s_flex_ali m-t-25'>
      <span class='mr15'>
        <a-button type="primary" v-has:createProductCateOne="visibleToggle">
          新增一级分类
        </a-button>
      </span>
      <span class='mr15' v-if="cateList.length">
        <a-button type="link" @click="changActiveKey">
           {{activeKey.length?'收起所有分类':'展开所有分类'}}
        </a-button>
      </span>
    </div>
    <a-collapse v-if="cateList.length" @change="changActive" v-model:activeKey="activeKey">
      <a-collapse-panel :header="v.group_name" v-for="(v,key) in cateList" :key='String(key)' >
        <template #extra>
          <span class='p-r-400 ds-i-b '>
            <a-button type="link">
              产品数量({{v.total}}) 
            </a-button>
          </span>
          <a-button type="link" v-has:createProductCateTwo="()=>{visibleToggle();group.p_id=v.id;}">
            新增二级分类
          </a-button>-
          <a-button type="link" v-has:editProductCateOne="()=>{group=JSON.parse(JSON.stringify(v));visible=true;groupForm.resetFields()}">
            修改
          </a-button>-
          <a-button type="link" v-has:delProductCateOne="()=>del(v.id)">
            删除
          </a-button>
        </template>
        <div v-for="(value,key) in v.child" :key="key" class='p-t-15 p-b-15 p-l-100 secondCate s_flex_bian_c m-b-10' style="background:#ECECEC;">
          <span class='width-100'>{{ value.group_name }}</span>
          <div class='p-r-150'>
            <a-button type="link" class='m-r-52'>
              产品数量({{value.total}})
            </a-button>
          </div>
          <div>
            <a-button type="link" v-has:editProductCateTwo="()=>{group=value;visible=true;groupForm.resetFields()}">
              修改
            </a-button>-
            <a-button type="link" v-has:delProductCateTwo="()=>del(value.id)">
              删除
            </a-button>
          </div>
        </div>
        <a-divider type="vertical" />
      </a-collapse-panel>
    </a-collapse>
    <a-empty v-if="!cateList.length" :description="false" />
  </a-card>
  <!-- 添加分类 -->
  <a-modal  :keyboard="false" title="分类管理" centered v-model:visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" destroyOnClose>
    <a-form ref="groupForm" :model="group" :label-col="{span:4}" :wrapper-col="{span:20}" help='限8个字符'>
      <a-form-item ref="group_name" label="分组名称" name="group_name" :rules="[{ required: true, message: '请输入分类名称' },{ max: 20, message: '分组名称不超过20个字符' }]">
        <a-input v-model:value="group.group_name" placeholder='请输入分类名称'/>
      </a-form-item>
      <a-form-item ref="sort" label="排序" name="sort">
        <a-input v-model:value="group.sort" />
      </a-form-item>
      <a-form-item ref="id" label="id" name="id" hidden>
        <a-input v-model:value="group.id" />
      </a-form-item>
      <a-form-item ref="p_id" label="p_id" name="p_id" hidden>
        <a-input v-model:value="group.p_id" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { iscode } from "@/utils/app";
import { onMounted, reactive, toRefs, ref, watch } from "vue";
import store from '@/store'
import config from '@/config'
import {
  getProductCate,
  createCateFirst,
  createCateSecond,
  updateCate,
  deleteCate,
} from "@/api/product.js";
import { getToken } from '@/libs/util'
import { Modal } from "ant-design-vue";
export default {
  name: "product",
  setup(props) {
    const state = reactive({
      cateList: [],
      visible: false,
      confirmLoading: false,
      activeKey: "",
      link:''
    });
    state.link=config.cloudUrl[process.env.VUE_APP_type] + 'product/productCate?picdomain=' + store.state.user.info.picdomain + '&token=' + getToken()+'&brand_mark='+store.state.user.info.brand_mark;
    const initData = async () => {
      let result = await getProductCate().then((res) => res.data);
      state.cateList = result.data;
    };
    watch(state.visible, () => {
      groupForm.value.resetFields();
    });

    // 定义分类表单绑定数据
    const group = ref({ group_name: "", sort: 100, id: null, p_id: null });
    // 定义分类表单ref
    const groupForm = ref();
    // 提交
    const handleOk = () => {
      groupForm.value
        .validate()
        .then(async (res) => {
          state.confirmLoading = true;
          var result;
          if (!res.id && !res.p_id) {
            result = await createCateFirst(res);
          } else if (!res.id && res.p_id) {
            // 新增二级分类
            result = await createCateSecond(res);
          } else {
            // 修改分类
            result = await updateCate(res.id, res);
          }
          if (iscode(result.data, true)) {
            state.visible = false;
            initData();
            groupForm.value.resetFields();
          }

          state.confirmLoading = false;
        })
        .catch((error) => {});
    };
    // 弹出表单
    const visibleToggle = () => {
      group.value = { group_name: "", sort: 100, id: null, p_id: null };
      state.visible = true;
      //  groupForm.value.resetFields();
    };
    // 删除
    const del = (id) => {
      Modal.confirm({
        centered: true,
        content: "删除后将无法恢复，您确定要删除吗？",
        onOk: async () => {
          let res = await deleteCate(id).then((res) => res.data);
          if (iscode(res, true)) {
            initData();
          }
        },
      });
    };
    const changActiveKey=()=>{
      if(state.activeKey.length){
        state.activeKey=[]
      }else{
        state.activeKey=[]
        state.cateList.forEach((v,key)=>{
          state.activeKey.push(String(key))
        })
      }
    }
    const changActive = (key) => {
      state.activeKey=[]
      key.forEach(element => {
        state.activeKey.push(String(element))
      });
      // state.activeKey=[key]
    };
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      handleOk,
      group,
      groupForm,
      del,
      visibleToggle,
      changActive,
      changActiveKey,
      getToken
    };
  },
};
</script>
